import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1691425700573-5e2e6e4f6157?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyYWwlMjBlbGV2YXRpb24lMjBnbGFzcyUyMGNvbmNyZXRlfGVufDB8fHx8MTc4OTAyMzEyM3ww&ixlib=rb-4.1.0&q=85";

export const Hero = () => (
  <section id="top" className="relative overflow-hidden bg-paper pt-28 md:pt-32" data-testid="hero-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <div className="relative overflow-hidden rounded-3xl" data-testid="hero-visual">
        <motion.img
          initial={{ scale: 1.12 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          src={HERO_IMG}
          alt="Premium residential building elevation"
          className="h-[520px] w-full object-cover md:h-[620px]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/35 to-transparent" aria-hidden="true" />

        <div className="absolute inset-0 flex items-center">
          <div className="max-w-2xl p-8 md:p-14">
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="font-spec text-[11px] uppercase tracking-[0.25em] text-white/70"
              data-testid="hero-overline"
            >
              Urban Veera · Bengaluru
            </motion.p>
            <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.04] tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="hero-headline">
              <span className="block overflow-hidden">
                <motion.span className="block" initial={{ y: "105%" }} animate={{ y: "0%" }} transition={{ duration: 0.9, delay: 0.45, ease: [0.76, 0, 0.24, 1] }}>
                  What if your ₹4 crore
                </motion.span>
              </span>
              <span className="block overflow-hidden">
                <motion.span className="block" initial={{ y: "105%" }} animate={{ y: "0%" }} transition={{ duration: 0.9, delay: 0.62, ease: [0.76, 0, 0.24, 1] }}>
                  property could <span className="text-amber">do more?</span>
                </motion.span>
              </span>
            </h1>
            <motion.p
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.9 }}
              className="mt-6 max-w-lg text-base leading-relaxed text-white/80 md:text-lg"
              data-testid="hero-subtext"
            >
              Premium property models built around land and building ownership —
              structured for stronger rental potential.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 1.05 }}
              className="mt-9 flex flex-wrap items-center gap-4"
            >
              <a
                href="#contact-form"
                data-testid="hero-cta-consultation"
                className="group flex items-center gap-2.5 rounded-full bg-amber px-7 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-amberdark"
              >
                Get in Touch With Our Team
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <a
                href="#model"
                data-testid="hero-cta-model"
                className="group flex items-center gap-2 rounded-full border border-white/40 px-7 py-4 text-sm font-bold text-white backdrop-blur-sm transition-colors duration-300 hover:border-amber hover:text-amber"
              >
                Discover the Model
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </motion.div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.3 }}
          className="absolute bottom-6 right-6 hidden rounded-2xl bg-paper/90 px-6 py-4 backdrop-blur-md md:block"
          data-testid="hero-stat-plate"
        >
          <p className="font-spec text-[10px] uppercase tracking-[0.22em] text-steel">Project models</p>
          <p className="mt-1 font-display text-xl font-extrabold tracking-tight text-navy">₹4 Cr – ₹27 Cr+</p>
        </motion.div>

        <div className="absolute bottom-6 left-8 hidden items-center gap-2 md:flex" data-testid="hero-scroll-indicator">
          <ArrowDown size={14} className="animate-bounce text-white/70" />
          <span className="font-spec text-[10px] uppercase tracking-[0.25em] text-white/70">Scroll</span>
        </div>
      </div>
    </div>
  </section>
);
